export const FIELD_SCHEDULE_API_ACCEPTED_DATE_FORMAT = "YYYY/MM/DD HH:mm:ss";
export const FIELD_SCHEDULE_API_DATE_FORMAT = "YYYY/MM/DD";
export const FIELD_SCHEDULE_API_TIME_FORMAT = "HH:mm:ss";
export const FIELD_SCHEDULE_DEFAULT_API_DATE_FORMAT = "YYYY/MM/DD HH:mm:00";
export const FIELD_SCHEDULE_UI_DATE_FORMAT = "MMM DD";
export const FIELD_SCHEDULE_UI_TIME_FORMAT = "hh:mm A";
export const RESPONDENT_FILTERS_API_DATE_FORMAT = "YYYY/MM/DD";
export const RESPONDENT_FILTERS_UI_DATE_FORMAT = "MM/DD/YYYY";
